import React from "react";

/* eslint-disable max-len */
export default function AdminStatisticsIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} viewBox="0 0 30 30">
            <g data-name="\u30B0\u30EB\u30FC\u30D7 465">
                <g
                    data-name="\u30B0\u30EB\u30FC\u30D7 455"
                    transform="translate(-40 -395) translate(42 402)"
                >
                    <path
                        data-name="\u30D1\u30B9 8054"
                        d="M9.619 24.712h-.114a2.425 2.425 0 01-1.73-.813 2.456 2.456 0 01-.643-1.8 2.417 2.417 0 01.815-1.727 2.466 2.466 0 011.8-.642 2.425 2.425 0 011.73.813 2.456 2.456 0 01.643 1.8 2.417 2.417 0 01-.815 1.727 2.481 2.481 0 01-1.687.657zm0-3.554a1.085 1.085 0 00-.715.271 1.033 1.033 0 00-.343.728 1.094 1.094 0 00.272.756 1.036 1.036 0 00.729.343 1.1 1.1 0 00.758-.271 1.033 1.033 0 00.343-.728 1.094 1.094 0 00-.272-.756 1.036 1.036 0 00-.729-.343z"
                        transform="translate(-8.127 -8.727)"
                        fill="#9c9c9c"
                    />
                    <path
                        data-name="\u30D1\u30B9 8055"
                        d="M14.51 18.613h-.11a2.494 2.494 0 112.618-2.37 2.417 2.417 0 01-.816 1.727 2.483 2.483 0 01-1.688.657zm0-3.555a1.064 1.064 0 00-.043 2.127 1.1 1.1 0 00.758-.271 1.033 1.033 0 00.343-.728 1.068 1.068 0 00-1.016-1.114h-.042z"
                        transform="translate(-6.948 -10.018)"
                        fill="#9c9c9c"
                    />
                    <path
                        data-name="\u30D1\u30B9 8056"
                        d="M23.009 23.232H22.9a2.425 2.425 0 01-1.73-.813 2.456 2.456 0 01-.643-1.8 2.417 2.417 0 01.815-1.727 2.466 2.466 0 011.8-.642 2.425 2.425 0 011.73.813 2.456 2.456 0 01.643 1.8 2.417 2.417 0 01-.815 1.727 2.481 2.481 0 01-1.687.657zm0-3.554a1.085 1.085 0 00-.715.271 1.033 1.033 0 00-.343.728 1.094 1.094 0 00.272.756 1.036 1.036 0 00.729.343 1.1 1.1 0 00.758-.271 1.033 1.033 0 00.343-.728 1.094 1.094 0 00-.272-.756 1.036 1.036 0 00-.729-.343z"
                        transform="translate(-6.574 -8.99)"
                        fill="#9c9c9c"
                    />
                    <path
                        data-name="\u30D1\u30B9 8057"
                        d="M30.74 15.013h-.114a2.494 2.494 0 112.618-2.37 2.418 2.418 0 01-.816 1.727 2.483 2.483 0 01-1.688.657zm0-3.555a1.064 1.064 0 00-.043 2.127 1.1 1.1 0 00.758-.271 1.033 1.033 0 00.343-.728 1.068 1.068 0 00-1.016-1.114h-.042zm1.775 1.142z"
                        transform="translate(-6.248 -10.028)"
                        fill="#9c9c9c"
                    />
                    <path
                        data-name="\u7DDA 542"
                        transform="translate(18.214 4.536)"
                        fill="none"
                        stroke="#9c9c9c"
                        strokeLinecap="round"
                        strokeWidth={1.6}
                        d="M5 0L0 6"
                    />
                    <path
                        data-name="\u7DDA 544"
                        transform="translate(3.214 7.536)"
                        fill="none"
                        stroke="#9c9c9c"
                        strokeLinecap="round"
                        strokeWidth={1.6}
                        d="M3 0L0 4"
                    />
                    <path
                        data-name="\u7DDA 543"
                        transform="translate(9.214 7.536)"
                        fill="none"
                        stroke="#9c9c9c"
                        strokeLinecap="round"
                        strokeWidth={1.6}
                        d="M0 0L5 3"
                    />
                </g>
            </g>
        </svg>
    );
}
